import React from 'react';
import { LightsConfig } from '../seasonConfig';
import './GarlandLights.css';

interface GarlandLightsProps {
    config: LightsConfig;
    lightCount?: number;
}

const GarlandLights: React.FC<GarlandLightsProps> = ({ config, lightCount = 20 }) => {
    return (
        <div className="garland-lights">
            <div className="garland-lights__wire"></div>
            <div className="garland-lights__bulbs">
                {[...Array(lightCount)].map((_, i) => (
                    <span
                        key={i}
                        className="garland-lights__bulb"
                        style={{
                            '--bulb-color': config.colors[i % config.colors.length],
                            animationDelay: `${(i % 5) * 0.3}s`,
                        } as React.CSSProperties}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default GarlandLights;
